import { api } from "@lumberset/api-client";
import { MessageWorkspaceButton, TicketQueue } from "@lumberset/support-ui";
import { Button } from "@lumberset/ui";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../components/crumbs";

export const Route = createFileRoute("/_app/support/")({ component: SupportQueue });

function SupportQueue() {
  const navigate = useNavigate();
  return (
    <>
      <Crumbs trail={[{ label: "Support" }]} />
      <TicketQueue
        client={api}
        onOpen={(id) => navigate({ to: "/support/tickets/$id", params: { id } })}
        actions={
          <>
            <MessageWorkspaceButton
              client={api}
              onSent={(id) => navigate({ to: "/support/tickets/$id", params: { id } })}
            />
            <Button asChild size="small" variant="secondary">
              <Link to="/support/mine">My tickets</Link>
            </Button>
          </>
        }
      />
    </>
  );
}
